import { getNotificationsApiHeaders } from '@module/mdrt-org/shared/utils/helpers/get-headers';
import { mutateWithErrorHandling } from '@module/mdrt-org/shared/utils/http-services/mutate-with-error-handling';

export const postMultipleUserNotificationStatusUpdate = async ({
  accessToken,
  personId,
  upToNotificationId,
}: {
  accessToken: string | undefined;
  personId: number | undefined;
  upToNotificationId: string;
}) => {
  if (!(accessToken && personId)) {
    throw new Error('Access token or person ID is not available');
  }

  return await mutateWithErrorHandling(
    `${window.PUBLIC_ENV.apiBaseUrl}/${
      window.PUBLIC_ENV.notificationsApiRoute ?? 'notifications-api'
    }/Notifications/Users/${personId}/All/Read/${upToNotificationId}`,
    {
      headers: {
        ...getNotificationsApiHeaders(accessToken),
      },
      method: 'POST',
    }
  );
};
